import api from './api';

export interface LaunchItemInput {
  broadcastId: string; broadcastVersionNumber: number; broadcastSemanticHash: string;
  audienceSnapshotId: string; audienceVersionNumber: number; audienceSnapshotHash: string;
}
export interface LaunchInput {
  name: string; timezone: string; storeId: string; storeUrl: string; storePlatform: string;
  offerId: string; offerVersionNumber: number; offerSemanticHash: string; offerSourceHash: string;
  items: LaunchItemInput[];
}
export interface LaunchVersion extends LaunchInput {
  versionNumber: number; snapshotHash: string; createdAt: string;
  items: Array<LaunchItemInput & { position: number; scheduledFor: string; itemHash: string }>;
}
export interface Launch {
  id: string; status: 'ACTIVE' | 'CANCELLED'; latestVersionNumber: number;
  currentVersion: LaunchVersion; versions: LaunchVersion[];
  events?: Array<{ id: string; action: string; versionNumber: number; createdAt: string }>;
}
export interface LaunchPreflight {
  passed: boolean; reasonCodes: string[]; inputHash: string; evaluatedAt: string;
  enforcement: { ready: false; reasonCodes: string[] };
}
export interface LaunchStore { id: string; name: string; url: string; platform: string; isActive: boolean }
export interface LaunchOfferVersion { versionNumber: number; semanticHash: string; sourceHash: string; validFrom: string | null; validUntil: string | null }
export interface LaunchOffer { id: string; name: string; status: string; versions: LaunchOfferVersion[] }
export interface LaunchAudience {
  id: string; name: string; status: string;
  versions: Array<{ versionNumber: number; snapshotHash: string; segmentId: string; segmentVersionNumber: number;
    eligibleMemberCount: number; validUntil: string }>;
}
const base = (brandId: string) => `/marketing/brands/${encodeURIComponent(brandId)}`;
export const marketingLaunchApi = {
  list: (brandId: string, range: { from: string; to: string }) => api.get<{ launches: Launch[]; truncated: boolean }>(`${base(brandId)}/launches`, { params: range }),
  detail: (brandId: string, id: string) => api.get<Launch>(`${base(brandId)}/launches/${encodeURIComponent(id)}`),
  options: (brandId: string) => api.get<{ stores: LaunchStore[]; offers: LaunchOffer[]; audiences: LaunchAudience[] }>(`${base(brandId)}/launch-options`),
  preflight: (brandId: string, input: LaunchInput, launchId?: string) => api.post<LaunchPreflight>(`${base(brandId)}/launch-preflight`, { input, launchId }),
  write: (brandId: string, action: 'create' | 'revise' | 'cancel', input: LaunchInput | { expectedLatestVersionNumber: number; reasonCode: string }, key: string, launch?: Launch) => {
    const path = action === 'create' ? '/launches' : `/launches/${encodeURIComponent(launch!.id)}/${action === 'revise' ? 'revisions' : 'cancel'}`;
    return api.post<{ duplicate: boolean; result: { launchId: string; version: LaunchVersion } }>(`${base(brandId)}${path}`,
      action === 'revise' ? { ...input, expectedLatestVersionNumber: launch!.latestVersionNumber } : input,
      { headers: { 'Idempotency-Key': key } });
  },
};
